"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("@emotion/react");
var react_components_1 = require("@gamepark/react-components");
var react_2 = require("react");
var react_i18next_1 = require("react-i18next");
var Menu_1 = require("../Menu");
var Failure_1 = __importDefault(require("./Failure"));
var useFailures_1 = __importDefault(require("./useFailures"));
function FailuresDialog(props) {
    var t = (0, react_i18next_1.useTranslation)().t;
    var _a = (0, useFailures_1.default)(), failures = _a[0], clearFailures = _a[1];
    var _b = (0, react_2.useState)(''), displayedFailure = _b[0], setDisplayedFailure = _b[1];
    (0, react_2.useEffect)(function () {
        if (failures.length) {
            setDisplayedFailure(failures[0]);
        }
        else {
            setTimeout(function () { return setDisplayedFailure(''); }, 500);
        }
    }, [failures]);
    var description = failuresDescription[displayedFailure] || fallbackDescription(displayedFailure);
    return ((0, jsx_runtime_1.jsxs)(react_components_1.Dialog, __assign({ open: failures.length > 0, css: Menu_1.menuDialogCss }, props, { children: [(0, jsx_runtime_1.jsx)("h2", { children: description.title(t) }), (0, jsx_runtime_1.jsx)("p", { children: description.text(t) }), (0, jsx_runtime_1.jsx)("button", __assign({ css: [Menu_1.menuButtonCss, inDialogButton], onClick: function () { return clearFailures(); } }, { children: t('OK') })), displayedFailure === Failure_1.default.MOVE_FORBIDDEN && (0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { defaults: "failure.dialog.play2", components: [(0, jsx_runtime_1.jsx)("button", { onClick: function () { return window.location.reload(); } })] }) })] })));
}
exports.default = FailuresDialog;
var failuresDescription = (_a = {},
    _a[Failure_1.default.NETWORK] = {
        title: function (t) { return t('Whoops...'); },
        text: function (t) { return t('failure.dialog.network'); }
    },
    _a[Failure_1.default.MOVE_FORBIDDEN] = {
        title: function (t) { return t('Move unauthorized!'); },
        text: function (t) { return t('failure.dialog.play'); }
    },
    _a[Failure_1.default.UNDO_FORBIDDEN] = {
        title: function (t) { return t('Too late!'); },
        text: function (t) { return t('failure.dialog.undo'); }
    },
    _a[Failure_1.default.TUTORIAL_MOVE_EXPECTED] = {
        title: function (t) { return t('Move not expected in the tutorial'); },
        text: function (t) { return t('failure.dialog.tutorial'); }
    },
    _a);
var fallbackDescription = function (failure) { return ({
    title: function (t) { return t('Unknown error:'); },
    text: function () { return failure; }
}); };
var inDialogButton = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 0 0 auto;\n  font-size: 1.125em;\n"], ["\n  margin: 0 0 0 auto;\n  font-size: 1.125em;\n"])));
var templateObject_1;
